(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "18615fe8d12cd9f108cf6480500b2d38fa2adfc8"
};